import React from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { equals } from "ramda";

import { RoutePaths } from "src/app/model";
import { useLocale } from "src/shared/i18n";

import { pages } from "../../model/constants";

export const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { subPath, toRoute } = useLocale();

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null,
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (path?: RoutePaths) => {
    if (!!path) {
      navigate(toRoute(path));
      setTimeout(() => {
        const section = document.getElementById(path);
        if (!!section && !equals(RoutePaths.TOOLS, path)) {
          section.scrollIntoView({ behavior: "smooth" });
        } else {
          window.scrollTo(0, 0);
        }
      }, 0);
    }
    setAnchorElNav(null);
  };

  const handleChange = (path: RoutePaths) => {
    setTimeout(() => {
      const section = document.getElementById(path);
      if (!!section && !equals(RoutePaths.TOOLS, path)) {
        section.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo(0, 0);
      }
    }, 0);
  };

  return (
    <>
      <Box sx={{ display: { md: "none", xs: "flex" } }}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>

        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          color="secondary"
          open={Boolean(anchorElNav)}
          onClose={() => handleCloseNavMenu()}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          {pages.map((page) => (
            <MenuItem
              key={page.value}
              onClick={() => handleCloseNavMenu(page.value)}
              selected={equals(page.value, subPath)}
              sx={{
                "&.Mui-selected": {
                  color: "primary.light",
                },
                "&:hover:not(.Mui-selected)": {
                  textDecoration: "none",
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                },
              }}
            >
              <Typography
                sx={{ textAlign: "center", textTransform: "capitalize" }}
              >
                {t(page.labelKey)}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>

      <Tabs
        value={subPath}
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
          marginLeft: "auto",
        }}
        onChange={(_, newValue) => {
          handleChange(newValue);
        }}
      >
        {pages.map((page) => (
          <Tab
            key={page.value}
            label={t(page.labelKey)}
            value={page.value}
            to={toRoute(page.value)}
            component={Link}
            iconPosition="start"
          />
        ))}
      </Tabs>
    </>
  );
};
